import { ILayout, layoutStore_NS, rootStore } from '@/shared/store';

class LayoutService {
    constructor() {
        window.addEventListener(
            'resize',
            () => {
                const isPad = window.innerWidth < 1000;
                const obj = { ...this.data };
                obj.isPad = isPad;
                obj.collapsed = isPad;
                this.set(obj);
            },
            false
        );
        const isPad = window.innerWidth < 1000;
        const obj = { ...this.data };
        obj.isPad = isPad;
        obj.collapsed = isPad;
        this.set(obj);
    }

    get data(): ILayout {
        return rootStore.getters[`${layoutStore_NS}/get`];
    }

    public set(val: ILayout) {
        rootStore.commit(`${layoutStore_NS}/set`, val);
    }

    public changeTheme() {
        const data = JSON.parse(JSON.stringify(this.data));
        data.theme = data.theme === 'dark' ? 'light' : 'dark';
        this.set(data);
    }
}

const layoutService = new LayoutService();
export default layoutService;
